import { Adobe } from 'eplayer-core'

import { fileToUTF16 } from '@common/io/file'
import { getMIMESubtype } from '@common/mime.utils'

export const { adobeEmbedFromAdobeJS, adobeLabelsFromAdobeJS } = Adobe

export async function adobeStrFromJsFile(jsFile: File) {
  if (getMIMESubtype(jsFile.type) !== 'javascript') {
    throw new Error
  }
  const str = await fileToUTF16(jsFile)
  return Adobe.transformAdobeAST(str)
}
